import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './error.component'

let module = angular.module('error', [
  uiRouter
])
.config(($urlRouterProvider) => {
  'ngInject'
  $urlRouterProvider.otherwise('error/404')
})

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('error', {
      url: '/error/:errorCode',
      component: 'error'
    })
})

.component('error', component)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/error/index.js